import {lazy} from '@aboutyou/lazy-imports';

export const PushNotification = lazy(() =>
  import('./PushNotification.eager').then(mod => ({
    default: mod.PushNotificationEager,
  })),
);
